export const LOCALYSER_WEBSITE_URL = 'https://www.localyser.com';
